import { fmtNumber } from "../../lib/format";

export const PAGE_SIZE = 50;

/** Paginação simples das tabelas das abas (no lugar de uma caixa com rolagem). */
export function Pager({ page, total, onPage, noun }: { page: number; total: number; onPage: (p: number) => void; noun: string }) {
  const pages = Math.ceil(total / PAGE_SIZE);
  if (pages <= 1) return null;
  const first = page * PAGE_SIZE + 1;
  const last = Math.min(total, (page + 1) * PAGE_SIZE);
  return (
    <div className="px-5 py-3 border-t border-surface-border flex flex-wrap items-center justify-between gap-2 text-xs text-gray-600">
      <span className="tabular-nums">{fmtNumber(first)} a {fmtNumber(last)} de {fmtNumber(total)} {noun}</span>
      <div className="flex gap-2">
        <button type="button" className="btn-secondary text-xs py-1.5" disabled={page === 0} onClick={() => onPage(page - 1)}>Anterior</button>
        <span className="self-center tabular-nums">Página {page + 1} de {pages}</span>
        <button type="button" className="btn-secondary text-xs py-1.5" disabled={page >= pages - 1} onClick={() => onPage(page + 1)}>Próxima</button>
      </div>
    </div>
  );
}
